import { musicVolume } from './constants';
import { loadSettings } from './util';


export class Preloader extends Phaser.Scene {
    constructor() {
        super('preloader');
    }

    preload() {
        //load images
        this.load.image('farback', 'Images/farback.png');
        this.load.image('redlaser', 'Images/redlaser.png');
        this.load.image('bluelaser', 'Images/bluelaser2.png');
        this.load.image('asteroid0a', 'Images/asteroid1.png');
        this.load.image('asteroid0b', 'Images/asteroid1b.png');
        this.load.image('asteroid1', 'Images/asteroid2.2.png');
        this.load.image('station', 'Images/station.png');
        this.load.spritesheet('ship', 'Images/shipsheet3.png', { frameWidth: 111, frameHeight: 63 });
        this.load.spritesheet('enemy0', 'Images/enemysheet4.png', { frameWidth: 80, frameHeight: 80 });
        this.load.spritesheet('enemy1', 'Images/bigenemysheet.png', { frameWidth: 80, frameHeight: 80 });
        this.load.image('enemyfire', 'Images/enemyfire.png');

        //load sounds
        this.load.audio('thrust', 'Sounds/thrust.wav');
        this.load.audio('left', 'Sounds/left.wav');
        this.load.audio('right', 'Sounds/right.wav');
        this.load.audio('laser', 'Sounds/laser.wav');
        this.load.audio('collide', 'Sounds/collide.wav');
        this.load.audio('levelup', 'Sounds/levelup.wav');
        this.load.audio('explode', 'Sounds/explode.wav');
        this.load.audio('gameover', 'Sounds/gameover.wav');
        this.load.audio('enemycollide', 'Sounds/enemycollide.wav');
        this.load.audio('enemyfire', 'Sounds/enemyfire.wav');
        this.load.audio('enemyexplosion', 'Sounds/enemyexplosion.wav');
        this.load.audio('enemylaser', 'Sounds/enemylaser3.wav');

        // NOTE: Marco's soundtrack (a multi-MB MP3) is deliberately NOT loaded
        // here - it would hold the title screen hostage until the whole file
        // downloads. create() streams it in the background instead.
    }

    create() {
        // Volume settings live in the global registry so they persist across
        // scenes and level restarts (adjustable on the pause screen). They are
        // seeded from localStorage so they also survive a page reload, falling
        // back to the defaults when nothing is stored.
        const saved = loadSettings();
        if (this.registry.get('musicVolume') === undefined) {
            this.registry.set('musicVolume',
                saved.musicVolume !== undefined ? saved.musicVolume : musicVolume);
        }
        if (this.registry.get('sfxVolume') === undefined) {
            this.registry.set('sfxVolume',
                saved.sfxVolume !== undefined ? saved.sfxVolume : 1);
        }

        // Show the title screen right away. We *launch* the splash (rather than
        // start it) so this Preloader scene stays alive to finish streaming
        // Marco's soundtrack in the background, without delaying startup.
        this.scene.launch('splash');
        this.loadMusicInBackground();
    }

    // The soundtrack is a multi-MB MP3; loading it up front would block the title
    // screen until the whole file arrives. Instead we stream it in the background
    // once the splash is already up, then register it as the global 'music'
    // sound. Every scene guards for a not-yet-loaded 'music', so nothing breaks
    // during the gap - the worst case is the music starting a second or two in.
    private loadMusicInBackground() {
        if (this.cache.audio.exists('music')) {
            this.registerMusic();
            this.scene.stop();
            return;
        }
        this.load.audio('music', 'Sounds/Space Game.mp3');
        this.load.once('complete', () => {
            if (this.cache.audio.exists('music')) {
                this.registerMusic();
            }
            this.scene.stop(); // the Preloader's job is done
        });
        this.load.start();
    }

    // Register the loaded soundtrack as the global 'music' sound (kept in the
    // registry so any scene can reach it: HUD mute, pause-screen volume). It is
    // started by the Level on entry and stopped on the splash / at game over, so
    // it only plays in-game and persists across level restarts.
    private registerMusic() {
        const music = this.sound.add('music', { loop: true, volume: this.registry.get('musicVolume') });
        this.registry.set('music', music);
        // If the download finished while the player was already in a level (they
        // started faster than the music loaded), start it now. Leaving the splash
        // needs a keypress, which unlocks audio - but guard for locked anyway.
        if (this.scene.isActive('level')) {
            if (this.sound.locked) {
                this.sound.once(Phaser.Sound.Events.UNLOCKED, () => music.play());
            } else {
                music.play();
            }
        }
    }
}
